import { axiosClient } from '@as-react/common-utils';
export const API_BACKEND_BASIC_AUTH = 'Basic Y3VzdG9tZXItYXBwOmN1c3RvbWVyLXNlY3JldA==';
export const authEndpoints = {
    authenticated: 'api/authenticated',
    login: 'api/oauth/login',
    registeredCheckout: 'api/oauth/login/checkout',
    logout: 'api/oauth/logout',
    forgot_password: 'api/credentials/forgot',
    login_social: 'api/oauth/login/social',
    login_social_checkout: 'api/oauth/login/social/checkout',
    login_guest: 'api/buy/login',
    login_return_guest: 'api/returnannounce/login',
};
class AuthApi {
    constructor() {
        this.socialLogin = (servicesApi, defaultRequestParams, accountData, isBuyPage = false, isConfirmationPage = false) => {
            const axiosConfig = {
                method: 'POST',
                url: `${servicesApi}${isBuyPage && !isConfirmationPage ? authEndpoints.login_social_checkout : authEndpoints.login_social}`,
                params: defaultRequestParams,
                withCredentials: true,
                data: accountData,
                headers: {
                    Authorization: API_BACKEND_BASIC_AUTH,
                },
            };
            return axiosClient.request(axiosConfig);
        };
    }
    login(apiPrefix, defaultRequestParams, username, password, keepSignedIn) {
        const axiosConfig = {
            method: 'POST',
            url: `${apiPrefix}${authEndpoints.login}`,
            headers: {
                Authorization: API_BACKEND_BASIC_AUTH,
            },
            params: Object.assign(Object.assign({}, defaultRequestParams), { keepSignedIn }),
            withCredentials: true,
        };
        if (username || password) {
            axiosConfig.data = {
                username,
                password,
            };
        }
        return axiosClient.request(axiosConfig);
    }
    registeredLogin(apiPrefix, defaultRequestParams, username, password, keepSignedIn) {
        const axiosConfig = {
            method: 'POST',
            url: `${apiPrefix}${authEndpoints.registeredCheckout}`,
            headers: {
                Authorization: API_BACKEND_BASIC_AUTH,
            },
            params: Object.assign(Object.assign({}, defaultRequestParams), { keepSignedIn }),
            withCredentials: true,
        };
        if (username || password) {
            axiosConfig.data = {
                username,
                password,
            };
        }
        return axiosClient.request(axiosConfig);
    }
    logout(apiPrefix, defaultRequestParams) {
        const axiosConfig = {
            method: 'POST',
            url: `${apiPrefix}${authEndpoints.logout}`,
            params: defaultRequestParams,
            withCredentials: true,
        };
        return axiosClient.request(axiosConfig);
    }
    isAuthenticated(apiPrefix) {
        const axiosConfig = {
            method: 'GET',
            url: `${apiPrefix}${authEndpoints.authenticated}`,
            withCredentials: true,
        };
        return axiosClient.request(axiosConfig);
    }
    loginGuest(apiPrefix, defaultRequestParams, username, exploreMoreCardNumber) {
        const axiosConfig = {
            method: 'POST',
            url: `${apiPrefix}${authEndpoints.login_guest}`,
            headers: {
                Authorization: API_BACKEND_BASIC_AUTH,
            },
            params: defaultRequestParams,
            withCredentials: true,
            data: { username, exploreMoreCardNumber },
        };
        return axiosClient.request(axiosConfig);
    }
    loginReturnGuest(apiPrefix, { language, mainWebshop, shopId }, userName, orderNumber) {
        const axiosConfig = {
            method: 'POST',
            url: `${apiPrefix}${authEndpoints.login_return_guest}`,
            data: {
                email: userName,
                language,
                mainWebshop,
                shopId,
                orderId: orderNumber,
            },
            withCredentials: true,
        };
        return axiosClient.request(axiosConfig);
    }
}
export default new AuthApi();
